var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(_setup.Title,{staticClass:"tw-text-center tw-mb-5"},[_vm._v("\n    Redtail\n  ")]),_vm._v(" "),_c(_setup.CRMContactsTable,{staticClass:"tw-mb-6",attrs:{"app":_vm.app}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }